import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import Header from '../Components/Common/Header';
import DesktopHeader from '../Desktop/Common/Header';
import Navigator from '../Components/Common/Navigator';
import Footer from '../Desktop/Common/Footer';

function PrivateRoute({ component: Component, ...rest }) {
    let authed = localStorage.getItem('jwt_access_token') || sessionStorage.getItem('jwt_access_token') ? true : false;
    let pageTitle = rest.title ? rest.title : '';
    let headerClassname = rest.headerClass ? rest.headerClass : '';

    return (
        <Route
            {...rest}
            render={(props) =>
                authed ? (
                    <>
                        {rest.isMobileOnly ? (
                            <Header {...props} headerClassname={headerClassname} pageTitle={pageTitle} />
                        ) : (
                            <DesktopHeader {...props} />
                        )}
                        <div className='container'>
                            <Component {...props} extraMarketChild={rest.extraMarketChild} />
                        </div>
                        {rest.isMobileOnly ? (
                            <Navigator {...props} title={pageTitle} />
                        ) : (
                            <Footer {...props} />
                        )}
                    </>
                ) : (
                    <Redirect to={{ pathname: '/', state: { from: props.location } }} />
                )
            }
        />
    );
}

export default PrivateRoute;
